import React, { Component } from 'react';
import { connect } from 'react-redux';

import Toolbar from './Toolbar';
import Layers from '../components/Layers';

import CanvasContainer from '../components/CanvasContainer';
// import CanvasFooter from '../components/CanvasFooter';

class Canvas extends Component {
  render() {
    const currentSurface = this.props.objects.present.currentSurface;

    return (
      <div className="t-container-canvas">
        <Toolbar />
        <Layers />
        <CanvasContainer
          canvasWidth={currentSurface.surface.background.width}
          canvasHeight={currentSurface.surface.background.height}/>
        {/*<CanvasFooter/>*/}
      </div>
    );
  }
}

export default connect(f => f, {})(Canvas);




// WEBPACK FOOTER //
// ./src/containers/Canvas.js